import { TranslationContext } from 'contexts/translation-context';
import { useContext } from 'react';
import styled from 'styled-components';
import Lottie from 'lottie-react';
import spinningDiamond from 'assets/lottie-animations/spinning-diamond.json';
import { BlueLink } from 'components/common/link';

const Container = styled.div`
  background: ${props => props.theme.colors.white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid ${props => props.theme.colors.siteCardBorder};
  border-radius: 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  padding: 40px 56px 48px;
  width: 100%;
  max-width: 760px;
  box-sizing: border-box;

  @media (max-width: 999px) {
    border-radius: 16px;
    margin: 0 12px;
    padding: 28px 20px;
    width: calc(100% - 24px);
  }
`;
const Title = styled.div`
  font-size: 26px;
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
  margin-bottom: 20px;
  font-family: ${props => props.theme.fonts.FunnelDisplay};
  color: ${props => props.theme.colors.black};

  @media (max-width: 999px) {
    font-size: 24px;
  }
`;
const ContentMessage = styled.div`
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
  font-family: ${props => props.theme.fonts.interSans};
  color: ${props => props.theme.colors.siteBlack};
  white-space: break-spaces;

  @media (max-width: 999px) {
    font-size: 13px;
  }
`;

const StyledLink = styled(BlueLink)`
  font-family: ${props => props.theme.fonts.interSansSemiBold};
  color: ${props => props.theme.colors.siteIndigo};
  font-size: 14px;
  text-decoration: auto;

  @media (max-width: 999px) {
    font-size: 13px;
  }
`;

const ForQuestions = styled(ContentMessage)`
  margin-top: 16px;
`;

const AnimationWrapper = styled.div`
  height: 112px;
  width: 112px;
  margin-bottom: 12px;

  @media (max-width: 999px) {
    height: 96px;
    width: 96px;
  }
`;

const ThankYouScreenForPriceList = () => {
  const TRANSLATION_TEXT = useContext(TranslationContext) as { [key: string]: string };

  const handleContactUsClick = () => {
    window.open('https://www.rapnet.com/contact/support/', '_blank');
  };

  return (
    <Container>
      <AnimationWrapper>
        <Lottie animationData={spinningDiamond} loop autoplay />
      </AnimationWrapper>
      <Title>{TRANSLATION_TEXT.thank_you}</Title>
      <ContentMessage>{TRANSLATION_TEXT.renewal_request_has_been_sent}</ContentMessage>
      <ContentMessage>{TRANSLATION_TEXT.processed_once_payment_has_been_received}</ContentMessage>
      <ForQuestions>
        {TRANSLATION_TEXT.if_you_have_any_questions_please_feel_free}
        <StyledLink onClick={handleContactUsClick}>{TRANSLATION_TEXT.contact_us_lower}</StyledLink>
      </ForQuestions>
    </Container>
  );
};
export default ThankYouScreenForPriceList;
